import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import TableHeader from "../../../components/TableHeader/index";
import PageHeader from "../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../components/Pagination";
import LinkPlus from "../../../components/Link/LinkPlus";
import {getSchoolId, getSchoolYear} from "../../../utils/authority";
import ClassRoomController from "../../../services/data-declaration/class-room-controller";
import ModalDeleteNoti from "./modalDeleteNoti";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import GradeManager from "../../../components/Grade";
import PublicSecureAuthorization from "../../../services/system/secure-authorization/secure-authorization-controller";
import NotiController from "../../../services/system/noti/noti-controller";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import AutoSearchPeople from "../../../components/auto-search-people";
import StudentController from "../../../services/system/student/student-controller";
registerLocale("vi", vi);
class NotificationManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            principalId: "",
            principalName: "",
            principalUserName: "",

            studentId: -1,
            officerId: -1,
            parentId: -1,
            userId: -1,
            sort: 'DESC',
            title: "",
            state: "",
            yearId: parseInt(getSchoolYear()),
            type: "",
            startDate: null,
            endDate: null,
            recipientId: -1,
            pageNumber: 0,
            pageSize: 10,
            groupId: -1,
            gradeStr: "",

            listGroupUser: [],
            listData: [],
            listClass: [],
            listStudent: [],

            classRoomId: -1,
            gradeId: "",
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tiêu đề",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Ngày phát hành",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Loại thông báo",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Đối tượng nhận",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListNoti()
        this.getListClass()
        this.getListGroupUser()
        this.getListStudent()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListNoti();
            }
        );
    };
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            grade: this.state.gradeId,
            fullName: this.state.studentName,
            code: "",
            ethnic: "",
            gender: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    getType(type){
        if (type == "SYSTEM")
            return "Hệ thống";
        else if (type == "SCHOOL"){
            return "BGH Nhà trường";
        }else if (type == "HOC_PHI"){
            return "Học phí";
        }else if (type == "DIEM_DANH"){
            return "Điểm danh";
        }else if (type == "HOC_TAP"){
            return "Học tập";
        }
    }

    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClass: res.data.content,
            });
        })
    }
    getListNoti() {
        let payload = {
            classRoomId: parseInt(this.state.classRoomId),
            from:  this.state.startDate == null?"":this.state.startDate,
            gradeStr:  this.state.gradeId,
            officerId: parseInt(this.state.officerId),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
            stateStr:  this.state.state,
            studentId:  parseInt(this.state.studentId),
            title:  this.state.title,
            to:  this.state.endDate== null?"":this.state.endDate,
            typeStr:  this.state.type,

            yearId: parseInt(getSchoolYear()),
            schoolId: parseInt(getSchoolId()),
            groupId:  parseInt(this.state.groupId),
            recipientId:  this.state.recipientId,
            parentId:  parseInt(this.state.parentId),
            userId:  parseInt(this.state.userId),
        };
        NotiController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListNoti()
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
            this.getListNoti()
        });
    }
    renderClass() {
        return this.state.listClass.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "WAIT_PUBLISH",
                "name": "Chờ phát hành"
            },
            {
                "id": "PUBLISH",
                "name": "Hoạt động"
            },
            {
                "id": "LOCKED",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getState(state) {
        if (state == "PUBLISH")
            return "Đã kích hoạt"
        else if (state == "WAIT_PUBLISH")
            return "Chưa kích hoạt"
        else
            return "Đã khóa"
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    render() {
        let {gradeId, isShowText, listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="noti-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý thông báo"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Tiêu đề</label>
                                                <input
                                                    placeholder="Nhập tiêu đề"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.title}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({title: val.target.value.trim()})
                                                    }
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex"></div>
                                            {/*<div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">*/}
                                            {/*    <label className="col-md-4 label-item">Nhóm người dùng</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.group}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            this.state.group = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                group: e.target.value,*/}
                                            {/*                inEditing: true*/}
                                            {/*            }, ()=>{*/}
                                            {/*                this.onhandleSearch()*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option value="1">Tất cả</option>*/}
                                            {/*        {this.state.listGroupUser?.map((item, index) => <option value={item.role}>{item.role}</option>)}*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            state: e.target.value
                                                        }, ()=>{
                                                            this.onhandleSearch()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Loại thông báo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.type}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            type: e.target.value
                                                        }, ()=>{
                                                            this.onhandleSearch()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="SYSTEM">Hệ thống</option>
                                                    <option value="SCHOOL">BGH Nhà trường</option>
                                                    <option value="HOC_PHI">Học phí</option>
                                                    <option value="DIEM_DANH">Điểm danh</option>
                                                    <option value="HOC_TAP">Học tập</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            classRoomId: e.target.value,
                                                            inEditing: true
                                                        }, ()=>{
                                                            this.onhandleSearch()
                                                        })
                                                    }}
                                                >
                                                    <option value="0">Chọn lớp</option>
                                                    {this.renderClass()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Chọn học sinh</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listStudent}
                                                    getOptionLabel={option => option.fullName?option.fullName:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.studentName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên học sinh'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                studentName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.studentId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                studentId: val?.id,
                                                                studentName: val?.fullName,
                                                            }, ()=>{
                                                                this.onhandleSearch()
                                                            })
                                                        }else {
                                                            this.setState({
                                                                studentId: -1,
                                                                studentName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Chọn cán bộ</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.principalId}
                                                    principalName={this.state.principalName}
                                                    principalUsername={this.state.principalUsername}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername}, ()=>{
                                                        this.onhandleSearch()
                                                    })}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Từ ngày</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày phát hành"
                                                    selected={this.state.startDate === null ? "" : new Date(this.state.startDate)}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                startDate: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    startDate={new Date()}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tới ngày</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày phát hành"
                                                    selected={this.state.endDate === null ? "" : new Date(this.state.endDate)}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                endDate: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            }, ()=>{
                                                                this.onhandleSearch()
                                                            })
                                                        }
                                                    }
                                                    endDate={new Date()}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/them-moi-thong-bao",
                                                        state: {
                                                            fromDashboard: true,
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>

                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Xuất Excell
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.title}
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {row.dateActive ? moment(row.dateActive).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {this.getType(row.type)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.objectReceiveValue}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.state=="PUBLISH"?<span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>:row.state=="WAIT_PUBLISH"?<span className="badge badge-info" style={{color: "white"}}>Chờ kích hoạt</span>:<span className="badge badge-danger" style={{color: "white"}}>Khóa</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/sua-thong-bao",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteNoti
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default NotificationManagement;
